import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { getLookupList } from "../../Actions/lookupAPI";
import CommonCard from "./CommonCard"
import AddIcon from "../../UIComponents/AddIcon";
import $ from "jquery";
import { toast } from "react-toastify";
let SearchItems = {
  LookUpToSearch: "",
  LookUpName: "",
  PageNumber: 1,
  PageSize: 20
}
class LookupFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleName: "",
      searchData: {
        LookUpToSearch: "",
        LookUpName: "",
        PageNumber: 1,
        PageSize: 20
      }
    }
    this.SearchLookup = this.SearchLookup.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { match, LookupClear, dispatch } = nextProps;
    const { params } = match;
    const { type } = params;
    // if (LookupClear) {
    //   prevState.searchData.LookUpName = "";
    //   dispatch({ type: "LookupClear", data: false });
    // }
    if (type === "Interval") {
      prevState.searchData.LookUpToSearch = "intervals";
    }/*  else if (type === "Class") {
      prevState.searchData.LookUpToSearch = "class";
    } */ else if (type === "TypeofShip") {
      prevState.searchData.LookUpToSearch = "typeofship";
    }/* else if (type === "TypeofPort") {
      prevState.searchData.LookUpToSearch = "typeofport";
    } */ else if (type === "Category") {
      prevState.searchData.LookUpToSearch = "category";
    } else if (type === "EquipmentType") {
      prevState.searchData.LookUpToSearch = "equipmentType";
    } else if (type === "MakeAndModel") {
      prevState.searchData.LookUpToSearch = "makeandmodel";
    } else if (type === "Unit") {
      prevState.searchData.LookUpToSearch = "unit";
    } else if (type === "Zone") {
      prevState.searchData.LookUpToSearch = "zone";
    }
    prevState.titleName = type;
  }
  componentDidUpdate(prevProps) {
    const { params } = this.props.match
    const { type } = params
    if (prevProps.LookupClear) {
      this.getLookup();
      this.props.dispatch({ type: "LookupClear", data: false });
    }

    if (prevProps.match.params.type !== type) {
      let param = { ...SearchItems };
      this.setState({
        searchData: param
      }, () => {
        console.log(this.state.searchData.LookUpName, 'lookupname');
      });
    }
    if (prevProps.showSidePane !== this.props.showSidePane) {

      let param = { ...SearchItems };
      this.setState({
        searchData: param
      }, () => {
        console.log(this.state.searchData.LookUpName, 'lookupname');
        this.props.dispatch(getLookupList(this.state.searchData))
      });

    }
  }
  componentDidMount() {
    const { dispatch, match,t } = this.props;
    const { params } = match;
    const { type } = params;
    let param = { ...SearchItems };
    if (type === "EquipmentType") {
      dispatch({ type: 'SubBannerTitle', data: "Equipment Type" });
    }
    else if (type === "TypeofShip") {
      dispatch({ type: 'SubBannerTitle', data: "Type of Ship" });
    } else if (type === "MakeAndModel") {
      dispatch({ type: 'SubBannerTitle', data: "Make And Model" });
    }
    /* else if (type === "TypeofPort") {
      dispatch({ type: 'SubBannerTitle', data: "Type of Port" });
    } */
    else {
      dispatch({ type: 'SubBannerTitle', data: type });
    }
    // this.state.searchData.LookUpName = "";
    this.setState({
      searchData: param
    }, () => {
      console.log(this.state.searchData.LookUpName, 'lookupname');
    })
    this.setState({});
    //  dispatch(getLookupList(this.state.searchData));
    this.getLookup();
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchLookup(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);

  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  clearLookupName = () => {
    
    let param = { ...SearchItems };
    this.setState({
      searchData: param
    }, () => {
      console.log(this.state.searchData.LookUpToSearch, 'lookupname');
      this.props.dispatch(getLookupList(this.state.searchData))
    });
  }
  getLookup() {
    this.props.dispatch(getLookupList(this.state.searchData));
  }

  verifySearchItems = () => {
    let flag = true;
    if (this.state.searchData.LookUpName == "") {
      flag = false;
    }
    return flag;
  }

  SearchLookup(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch(getLookupList(this.state.searchData));
  }

  SearchLookup1(pgno) {
    const { dispatch, t } = this.props;
    if (this.state.searchData.LookUpName !== "") {

      this.state.searchData.PageNumber = pgno;
      dispatch(getLookupList(this.state.searchData));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    const { dispatch } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "Interval") {
      this.state.searchData.LookUpToSearch = "intervals";
      this.state.searchData.LookUpName = e.target.value;
      this.setState({});
    } else {
      this.state.searchData.LookUpToSearch = "lookup";
      this.state.searchData.LookUpName = e.target.value;
      this.setState({});
    }
  }

  ClearInput() {
    let param = { ...SearchItems }
    // this.state.searchData.LookUpName = "";
    // this.state.searchData.PageNumber = 1;
    // this.state.searchData.PageSize = 20;
    this.setState({
      searchData: param
    }, () => {
      this.props.dispatch(getLookupList(this.state.searchData));
    });
    // this.props.dispatch(getLookupList(this.state.searchData));
  }

  render() {
    const { showSidePane, LookupList, match, t } = this.props;
    const { params } = match;
    const { type } = params;
    const { flagList, titleName } = this.state;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                          {type === "Interval" ? `${t("IntervelScreen.Title")}` : type === "Category" ? `${t("CategoryScreen.Title")}` : type === "TypeofShip" ? `${t("TypeofShipScreen.Title")}` : type === "EquipmentType" ? `${t("EquipmentTypeScreen.Title")}` : type === "MakeAndModel" ? "Make And Model"/*  : type=="TypeofPort"? "Type of Port"  */ :
                            type === "Unit" ? `${t("UnitScreen.Title")}` : type === "Zone" ? `${t("ZoneScreen.Title")}` : type}
                        </h5>
                        <div className="m-1 flex"
                          onClick={() =>
                            this.Addlookup()
                          }>
                          <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        {type === "Interval" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">{t("IntervelScreen.Title")}</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder={t("IntervelScreen.Title")}
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null}
                        {type === "Category" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">{t("CategoryScreen.Title")}</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder={t("CategoryScreen.Title")}
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null}
                        {/*   {type === "Class" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">Class</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder=""
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null} */}
                        {type === "TypeofShip" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">{t("TypeofShipScreen.Title")}</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder={t("TypeofShipScreen.Title")}
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null}
                        {/*  {type === "TypeofPort" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">Type</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder=""
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null} */}
                        {type === "EquipmentType" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder={t("EquipmentTypeScreen.Title")}
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null}
                        {type === "Unit" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">{t("UnitScreen.Title")}</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder={t("UnitScreen.Title")}
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null}
                        {type === "Zone" ?
                          <div className="col-lg-6 m-auto">
                            <label className="form-label">{t("ZoneScreen.Title")}</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name={this.state.titleName}
                              value={this.state.searchData.LookUpName}
                              placeholder={t("ZoneScreen.Title")}
                              onChange={e => this.handleInputChange(e)}
                            ></input>
                          </div>
                          : null}
                        <div className="col-lg-6">
                          <br></br>
                          <div
                            className="search-btn-col pt-3"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchLookup1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {LookupList ? (
                <CommonCard
                  currentPage={(LookupList.pagination.currentPage - 1) * LookupList.pagination.pageSize}
                  arraylist={LookupList.data}
                  currentPage={(LookupList.pagination.currentPage - 1) * LookupList.pagination.pageSize}
                  titleName={this.state.titleName}
                  totalRecords={LookupList.pagination.totalcount ? LookupList.pagination.totalcount : 0}
                  pageSize={LookupList.pagination.pageSize}
                  setUpdatedState={(value) => this.SearchLookup(value)}
                  clearLookupName={this.clearLookupName}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  ShowSidePanel = (id) => {
    const { match } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Lookup/${match.params.type}/Edit/${id}`);
  };

  Addlookup = () => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Lookup/${this.state.titleName}/Add`);
    let param = { ...SearchItems }
    this.setState({
      searchData: param
    }, () => {
      this.props.dispatch(getLookupList(this.state.searchData));
    });
  };
}



function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    LookupList: state.lookupReducer.LookupList,
    LookupClear: state.lookupReducer.LookupClear
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(LookupFilter));

